import type { FancyLoaderProps } from './FancyLoader.types'

function FancyLoader(props: FancyLoaderProps) {
  const { text } = props

  return (
    <div
      data-testid="fancy-loader"
      className="flex flex-col items-center justify-center min-h-[200px] space-y-4"
    >
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="relative">
            {/* Spinning gradient ring */}
            <div className="w-16 h-16 border-4 border-transparent rounded-full animate-spin border-t-blue-500 border-r-purple-500" />
            {/* Pulsing dot in center */}
            <div className="absolute top-1/2 left-1/2 w-4 h-4 bg-blue-500 rounded-full animate-ping transform -translate-x-1/2 -translate-y-1/2" />
          </div>
          {text && (
            <span className="text-gray-600 font-medium animate-pulse">
              {text}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default FancyLoader
